import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full py-20 px-4 bg-cream" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <div className="text-center mb-12" data-id="element-92">
          <span className="text-terracotta font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-93">
            La Solución
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brown mb-6" data-id="element-94">
            Protocolo Vientre Plano & Energía 30-70
          </h2>
          <p className="font-body text-xl text-brown-light max-w-2xl mx-auto" data-id="element-95">
            No es una dieta mágica de una semana. Es un manual de instrucciones
            para resetear tu biología y que tu cuerpo vuelva a funcionar a tu
            favor.
          </p>
        </div>

        <div className="flex justify-center mb-14" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/95UPB9PoGkp88KAazRSLWd/heylloyd-image-1771418442528.png" alt="Protocolo Vientre Plano & Energía 30-70 — vista previa del producto" className="w-full max-w-lg rounded-xl shadow-lg" data-id="element-97" />
        </div>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-stone-100" data-id="element-98">
          <h3 className="text-2xl font-heading font-bold text-brown mb-8 text-center" data-id="element-99">
            ¿Qué vas a encontrar dentro del Protocolo?
          </h3>

          <ul className="space-y-6" data-id="element-100">
            <li className="flex items-start" data-id="element-101">
              <div className="flex-shrink-0 mt-1" data-id="element-102">
                <div className="bg-sage/20 rounded-full p-1" data-id="element-103">
                  <Check className="w-5 h-5 text-sage-dark" data-id="element-104" />
                </div>
              </div>
              <div className="ml-4" data-id="element-105">
                <h4 className="text-lg font-bold text-brown font-heading" data-id="element-106">
                  El Método de Reseteo del Vago
                </h4>
                <p className="text-brown-light font-body" data-id="element-107">
                  3 hábitos de 5 minutos para "encender" tu digestión antes de
                  cada comida.
                </p>
              </div>
            </li>

            <li className="flex items-start" data-id="element-108">
              <div className="flex-shrink-0 mt-1" data-id="element-109">
                <div className="bg-sage/20 rounded-full p-1" data-id="element-110">
                  <Check className="w-5 h-5 text-sage-dark" data-id="element-111" />
                </div>
              </div>
              <div className="ml-4" data-id="element-112">
                <h4 className="text-lg font-bold text-brown font-heading" data-id="element-113">
                  Guía de Compras en Argentina
                </h4>
                <p className="text-brown-light font-body" data-id="element-114">
                  Qué comprar en Coto, Carrefour o el chino de la vuelta (y qué
                  productos "fit" tenés que dejar de comprar hoy mismo porque te
                  inflaman).
                </p>
              </div>
            </li>

            <li className="flex items-start" data-id="element-115">
              <div className="flex-shrink-0 mt-1" data-id="element-116">
                <div className="bg-sage/20 rounded-full p-1" data-id="element-117">
                  <Check className="w-5 h-5 text-sage-dark" data-id="element-118" />
                </div>
              </div>
              <div className="ml-4" data-id="element-119">
                <h4 className="text-lg font-bold text-brown font-heading" data-id="element-120">
                  El Mapa de los 14 Días
                </h4>
                <p className="text-brown-light font-body" data-id="element-121">
                  Un plan paso a paso, de mujer a mujer, para pasar de sentirte
                  pesada a sentirte liviana y con pilas.
                </p>
              </div>
            </li>

            <li className="flex items-start" data-id="element-122">
              <div className="flex-shrink-0 mt-1" data-id="element-123">
                <div className="bg-sage/20 rounded-full p-1" data-id="element-124">
                  <Check className="w-5 h-5 text-sage-dark" data-id="element-125" />
                </div>
              </div>
              <div className="ml-4" data-id="element-126">
                <h4 className="text-lg font-bold text-brown font-heading" data-id="element-127">
                  El Secreto del Kéfir y las Enzimas
                </h4>
                <p className="text-brown-light font-body" data-id="element-128">
                  Cómo usar los alimentos fermentados locales para reconstruir
                  tu intestino sin gastar de más.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}